import {
  DOMAIN_BY_TYPE_FAILURE,
  DOMAIN_BY_TYPE_SUCCESS,
  ALL_DOMAIN_RESULTS_LIMIT,
  FILTERED_DOMAIN_RESULTS_LIMIT,
} from "../../constants";
import { createAction, createErrorAction } from "../../utils";
import unicodeTld from "lib/unicodeTld";

import { goToRoute } from "../goToRoute/goToRoute";

import loadHostingPackages from "../../../lib/loadHostingPackages";

const domainSearchSuccess = createAction(DOMAIN_BY_TYPE_SUCCESS);
const domainSearchFailure = createErrorAction(DOMAIN_BY_TYPE_FAILURE);

export const autoDomainSearch = (keyword, plan) => {
  return async (dispatch, getState, { api }) => {
    const { routing } = getState();

    dispatch(goToRoute(routing));

    const planToPackageId = {
      beginner: "PPS_SMALL",
      explorer: "PPS_MEDIUM",
      enthusiast: "PPS_LARGE",
      guru: "PPS_XXLARGE",
    };

    if (planToPackageId[plan]) {
      // Get plans and save it in sessionStorage
      // other apps on the site use the same function and
      // save the data in sessionStorage. This is to avoid
      // all apps requesting the plans individually.
      await loadHostingPackages();

      // Select the package on the backend
      await api.selectPackage(planToPackageId[plan]).then(
        (data) => {
          window.sessionStorage.setItem("ChosenPackage", planToPackageId[plan]);
          window.GTM && window.GTM.onPackageChange();
        },
        (err) => {
          console.error("Select package failed", err);
        },
      );
    }

    if (!keyword) {
      return false;
    }

    // Save keyword in localStorage
    window.localStorage.setItem("keyword", keyword);

    // API call
    return api
      .getDomainsByType(
        unicodeTld(keyword),
        "POPULAR",
        FILTERED_DOMAIN_RESULTS_LIMIT,
      )
      .then(
        (data) => {
          dispatch(
            domainSearchSuccess({
              domains: data.data.domains,
              currency: data.data.currency,
              pagination: data.pagination,
              defaultIncludeVat: data.data.defaultIncludeVat,
              decimalSeparator: data.data.decimalSeparator,
              type: "popular",
              keyword: keyword,
            }),
          );

          return api
            .getDomainsByType(
              unicodeTld(keyword),
              "ALL",
              ALL_DOMAIN_RESULTS_LIMIT,
            )
            .then((data) => {
              dispatch(
                domainSearchSuccess({
                  domains: data.data.domains,
                  currency: data.data.currency,
                  pagination: data.pagination,
                  defaultIncludeVat: data.data.defaultIncludeVat,
                  decimalSeparator: data.data.decimalSeparator,
                  type: "all",
                  keyword: keyword,
                }),
              );
            });
        },
        (err) => {
          dispatch(domainSearchFailure(err));
        },
      );
  };
};
